import {HIGH_CONTRAST_COLORS} from "../../pages/page-admin-organizations-branding/constants";

export const isHighContrastColor = (color: string) =>
  HIGH_CONTRAST_COLORS.includes(color);
